
<div class="container">

  <div class="header">

    <div class="title">
      <span><b>{{ title }}</b></span>
    </div>

    <div class="actions">

      <ng-content select="[actions]"></ng-content>
    
    </div>
  </div>

  <div class="content">

    <ng-content></ng-content>

  </div>
</div>
